
















































































































import { Vue, Component } from "vue-property-decorator";
import { Driver } from "@/services/index.defs";

@Component
export default class KbmViewPanel extends Vue {
    defaultKbm = 1.17;

    get driversKbm(): { driver: Driver; kbm: number }[] {
        return this.$store.direct.state.info.driverKbm;
    }

    calcDiscount(kbmValue: number): number {
        let discount = Math.round((+kbmValue - 1) * 100);
        return discount > 0 ? 0 : -1 * discount;
    }

    get minKbm(): number {
        if (this.driversKbm.length == 0) return this.defaultKbm;
        return Math.max.apply(
            Math,
            this.driversKbm.map(x => x.kbm)
        );
    }
}
